import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";

// Componentes de Shareds
import { NavBarScreen, SideBarScreen } from "../shared";
import { Main } from "../../theme";

// Componentes de Shared
import { useSidebarStore } from "../../store";
// Componentes de Usuarios
import { ActualizarUsuario, CrearUsuarios, ListadoClientes, ListadoOperarios, ListaUsuarios } from "../pages/usuarios";
// Componentes de Granjas
import { ActualizarGranja, CrearGranjas, ListadoGranjas, OpcionesGranja } from "../pages/granjas";
// Componentes de Galpon
import { ActualizarGalpon, ListadoGalpones, CrearGalpon, OpcionesGalpon, GalponesXGranja } from "../pages/galpones";
// Componentes de Encubadora
import { ActualizarEncubadora, CrearEncubadora, ListadoEncubadora } from "../pages/encubadora";
// Rutas de Todo Lo que se vea de Lotes
import { ActualizarLote, CrearLotes, InfomacionLote, ListadoLotes, LotesXGranja, OpcionesLotes } from "../pages/lotes";
// Rutas de Todo Los Productos
import { ActualizarProducto, CrearProducto, ListadoProductos, OpcionesProducto, ProductosStock } from "../pages/productos";
// Rutas de Todo Los Stock
import { HistorialStockXBodega, HistorialXProductoYBodega, NotificacionTraslados, StockXBodega } from "../pages/inventario";
// Rutas de Distribucion Lote
import { ConsumoScreen, CrearPlanilla, DetallesDescuento, DetallesTotalesLote, DistribucionLote, ListadoCargueros, ListadoPlanillas, ListadoMermas, OpcionesPlanilla, EditarPlanilla } from "../pages/lote-distri";
// Rutas de Proveedores
import { CrearActualizarProveedor, ListadoProveedor } from "../pages/proveedores";
// Rutas de Bodegas
import { ActualizarBodega, BodegasXGranja, CrearBodegas, ListadoBodegas, OpcionesBodega } from "../pages/bodegas";
// Rutas de Unidades de Medida
import { CrearCategoria, CrearUnidadMedida, ListadoCategoriaProductos, ListadoUnidadMedidas } from "../pages/unidadMedida";
// Facturas Solicitudes y ordenes de compra
import { ListadoFacturas, ListadoSolicitudes, ListOrdenesCompra, OpcionesFactura, OrdenCompraDetalles } from "../pages/facturas";
// Centros de Costo
import { EntradasCentroCosto, ListadoCentroCosto, OpcionesCentroCosto } from "../pages/centroCostos";






// Rutas de Perfil
import { CambioDePassword, DashboardScreen, MiPerfilScreen } from "../pages/dashboard/pages";
// Rutas de Vehiculos
import { ActualizarVehiculo, CrearVehiculo, ImagesSeguros, ListadoVehiculos } from "../pages/vehiculos";
// Rutas de Inventario
import { InventarioScreen, InventarioTodasBodegas, SalidasEntradasPorBodega, ListadoInventarioRaiz, TodoEntradasInventarioRaiz } from "../pages/inventario/pages";
// Rutas de Facturas y Abonos a Ellas
import { FacturasArchivadas, FacturasScreen, FiltrosFacturas, VerFactura, AbonosFacturaScreen } from "../pages/facturas/pages";
import { ListaNotificaciones } from "../pages/notificacion/ListaNotificaciones";
import { ListadoAbonosXPlanilla } from "../pages/AbonosPlanilla";
import { CrearUpdateCentroCosto } from "../pages/centroCostos/CrearUpdateCentroCosto";








export const AdminRoutes = () => {


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isSidebarOpen = useSidebarStore( state => state.isSidebarOpen );


    return (

        <Box sx={{ display:'flex', height:'100vh' }}>
            <NavBarScreen />
            <SideBarScreen />

            <Main open={isSidebarOpen && !isMobile} theme={undefined}>
                <Routes>
                    {/* Rutas de Inicio */}
                    <Route path="dashboard" element={ <DashboardScreen /> } />
                    <Route path="cambioclave" element={ <CambioDePassword /> } />
                    <Route path="miperfil" element={ <MiPerfilScreen /> } />
                    {/* Ruta de Usuarios */}
                    <Route path="admin" element={ <ListaUsuarios /> } />
                    <Route path="clientes" element={ <ListadoClientes /> } /> 
                    <Route path="operarios" element={ <ListadoOperarios /> } /> 
                    <Route path="user/:id/edit" element={ <ActualizarUsuario /> } />
                    <Route path="add/user" element={ <CrearUsuarios /> } />
                    {/* Ruta de Vehiculos */}
                    <Route path="list-vehiculo" element={ <ListadoVehiculos /> } />
                    <Route path="vehiculo" element={ <CrearVehiculo /> } />
                    <Route path="vehi/:id/edit" element={ <ActualizarVehiculo /> } />
                    <Route path="img/:id/seguros" element={ <ImagesSeguros /> } />
                    {/* Rutas de Granjas */}
                    <Route path="list-granjas" element={ <ListadoGranjas /> } />
                    <Route path="add/granja" element={ <CrearGranjas /> } />
                    <Route path="opcion/:id/granja" element={ <OpcionesGranja /> } />
                    <Route path="granja/:id/edit" element={ <ActualizarGranja /> } />
                    {/* Rutas de Galpones */}
                    <Route path="list-galpones" element={ <ListadoGalpones /> } />
                    <Route path="add/galpon" element={ <CrearGalpon /> } />
                    <Route path="galpon/:id/edit" element={ <ActualizarGalpon /> } />
                    <Route path="opcion/:id/galpon" element={ <OpcionesGalpon /> } />
                    <Route path="granja/:id/galpones" element={ <GalponesXGranja /> } />
                    {/* Rutas de Encubadora */}
                    <Route path="list-encuba" element={ <ListadoEncubadora /> } />
                    <Route path="add/encubadora" element={ <CrearEncubadora /> } />
                    <Route path="encuba/:id/edit" element={ <ActualizarEncubadora /> } />
                    {/* Rutas de Lotes */}
                    <Route path="list-lotes" element={ <ListadoLotes /> } />
                    <Route path="opcion/:id/lote" element={ <OpcionesLotes /> } />
                    <Route path="add/lote" element={ <CrearLotes /> } />
                    <Route path="lote/:id/edit" element={ <ActualizarLote /> } />
                    <Route path="lote/:id/info" element={ <InfomacionLote /> } />
                    <Route path="granja/:id/lotes" element={ <LotesXGranja /> } />
                    {/* Rutas de Distri Lote */}
                    <Route path="detalles/:id/consumo" element={ <ConsumoScreen /> } />
                    <Route path="lote/:id/distri" element={ <DistribucionLote /> } />
                    <Route path="detalles/:id/distri" element={ <DetallesTotalesLote /> } />
                    <Route path="detalles/:id/:descuento/descuento" element={ <DetallesDescuento /> } />
                    <Route path="planilla/:id/create" element={ <CrearPlanilla /> } />
                    <Route path="planilla/:id/:planilla/edit" element={ <EditarPlanilla /> } />
                    <Route path="detalles/:id/:descuento/planilla" element={ <ListadoPlanillas /> } />
                    <Route path="opcion/:id/planilla" element={ <OpcionesPlanilla /> } />
                    <Route path="planilla/:id/cargueros" element={ <ListadoCargueros /> } />
                    <Route path="planilla/:id/mermas" element={ <ListadoMermas /> } />
                    {/* Rutas de Bodegas */}  
                    <Route path="list-bodegas" element={ <ListadoBodegas /> } />
                    <Route path="add/bodega" element={ <CrearBodegas /> } />
                    <Route path="bodega/:id/edit" element={ <ActualizarBodega /> } />
                    <Route path="opcion/:id/bodega" element={ <OpcionesBodega /> } />
                    <Route path="granja/:id/bodegas" element={ <BodegasXGranja /> } />
                    {/* Rutas de Productos */}
                    <Route path="list-producto" element={ <ListadoProductos /> } />
                    <Route path="add/producto" element={ <CrearProducto /> } />
                    <Route path="producto/:id/edit" element={ <ActualizarProducto /> } />
                    <Route path="opcion/:id/producto" element={ <OpcionesProducto /> } />
                    <Route path="producto/:id/stock" element={ <ProductosStock /> } />
                    {/* Rutas de Inventarios */}
                    <Route path="bodega/:id/productos" element={ <StockXBodega /> } />
                    <Route path="bodega/:id/stockact" element={ <HistorialXProductoYBodega /> } />
                    <Route path="bodega/:id/historial" element={ <HistorialStockXBodega /> } />
                    <Route path="bodega/:id/notificaciones" element={ <NotificacionTraslados /> } />
                    {/* Rutas de Unidad de Medida y Categorias */}
                    <Route path="add/:id/medidas" element={ <CrearUnidadMedida /> } />
                    <Route path="add/:id/categoria" element={ <CrearCategoria /> } />
                    <Route path="list-unimedida" element={ <ListadoUnidadMedidas /> } />
                    <Route path="list-categoria" element={ <ListadoCategoriaProductos /> } />
                    {/* Rutas de Proveedor */}
                    <Route path="list-proveedor" element={ <ListadoProveedor /> } />
                    <Route path="add/:id/proveedor" element={ <CrearActualizarProveedor /> } />
                     {/* Rutas de Ordenes de compra y Factruas */}
                    <Route path="facturas/list" element={ <ListadoFacturas /> } />
                    <Route path="facturas/:id/opcion" element={ <OpcionesFactura /> } />
                    <Route path="ordencompra/list" element={ <ListOrdenesCompra /> } />
                    <Route path="ordencompra/:id/detalles" element={ <OrdenCompraDetalles /> } />
                    <Route path="solicitudes/list" element={ <ListadoSolicitudes /> } />
                    {/* Rutas de Proveedor */}
                    <Route path="list/centrocos" element={ <ListadoCentroCosto /> } />
                    <Route path="cencos/:id/add" element={ <CrearUpdateCentroCosto /> } />
                    <Route path="cencos/:id/entradas" element={ <EntradasCentroCosto /> } />
                    <Route path="add/:id/opciones" element={ <OpcionesCentroCosto /> } />















                    {/* <Route path="consumo-galponlote/:id" element={ <InformeConsumoPorBodega /> } /> */}
                    <Route path="abonosxplanilla/:id" element={ <ListadoAbonosXPlanilla /> } />
                    {/* <Route path="planilla/:id" element={ <PrepararVentaPlanilla /> } /> */}
                    <Route path="registros/:id" element={ <SalidasEntradasPorBodega /> } />
                    <Route path="todo-inventario" element={ <InventarioTodasBodegas /> } />
                    <Route path="inventario-raiz/:id" element={ <ListadoInventarioRaiz />} />
                    <Route path="todoinventario" element={ <TodoEntradasInventarioRaiz />} />
                    <Route path="inventario/:id" element={ <InventarioScreen /> } />
                    <Route path="notificaciones" element={ <ListaNotificaciones /> } />
                    {/* <Route path="ops" element={ <ListadoOps /> } />
                    <Route path="ver-op/:id" element={ <VerOp /> } /> */}
                    {/* <Route path="aprobar-op/:id" element={ <AprobarPedidosScreen /> } /> */}
                    <Route path="facturas" element={ <FacturasScreen /> } />
                    <Route path="factura/:id" element={ <VerFactura /> } />
                    <Route path="fact-archi" element={ <FacturasArchivadas /> } />   
                    <Route path="fact-filtro" element={ <FiltrosFacturas /> } />   
                    <Route path="abonos/:id" element={ <AbonosFacturaScreen /> } />

                    <Route path="/*" element={ <Navigate to="/admin/dashboard" />} />
                </Routes>
                
            </Main>
        </Box>
    )
}
